import loginWithGithub from '../loginWithGithub'; // Add this at the top
import React, { useState, useEffect} from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../AuthContext';
import PortfolioForm from '../components/PortfolioForm';
import PortfolioPreview from '../components/PortfolioPreview';



const PortfolioBuilder = () => {
  const { user } = useAuth();
  const [portfolioData, setPortfolioData] = useState(null);

  // Load portfolio from Firestore
  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      const ref = doc(db, 'portfolios', user.uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setPortfolioData(snap.data());
      } else {
        setPortfolioData({
          name: '',
          bio: '',
          skills: [],
          skillInput: '',
          projects: [{ title: '', description: '', link: '', color: '#ff007f' }],
          contact: '',
          profileImage: '',
          imageBorderColor: '#ff007f',
          themeColor: '#1a1a2e',
        });
      }
    };
    fetchData();
  }, [user]);

  // Auto-save changes
  useEffect(() => {
    if (user && portfolioData) {
      const save = async () => {
        await setDoc(doc(db, 'portfolios', user.uid), portfolioData);
      };
      save();
    }
  }, [user, portfolioData]);

  // UI when not logged in
  

  if (!user) {
    return (
      <div className="text-center text-white mt-5">
        <p>Please <strong>sign in with GitHub</strong> to build your portfolio.</p>
        <button className="btn btn-outline-light mt-3" onClick={loginWithGithub}>
          Sign in with GitHub
        </button>
      </div>
    );
  }

  if (!portfolioData) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center text-white" style={{ height: '70vh' }}>
        <div className="spinner-border text-info mb-3" role="status"></div>
        <p>Loading your portfolio...</p>
      </div>
    );
  }

  // ✅ Return full page layout with min height
  return (
  <>
    <div
      className="container-fluid builder-section py-5 px-4 fade-in"
      style={{ minHeight: 'calc(100vh - 120px)' }} 
    >
      <h2 className="text-center text-glow mb-4">Build Your Developer Portfolio</h2>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="row g-4">
            <div className="col-lg-6">
              <PortfolioForm data={portfolioData} setData={setPortfolioData} />
            </div>
            <div className="col-lg-6">
              <PortfolioPreview data={portfolioData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

  
};

export default PortfolioBuilder;
